"use client";
import React, { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Link from "next/link";
import Footer from "@/components/Footer";
import WWD from "@/components/Wwd";
import FAQ from "@/components/Faq";
import FORM from "@/components/Form";

export default function Home() {
  const [isChecked, setIsChecked] = useState(true);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <main className="overflow-x-hidden">
      <div className="hero-background lg:overflow-hidden h-[600px] md:h-[650px] lg:h-[676px] xl:h-[700px]">
        <Navbar />
        <div className="pt-20 max-w-[1040px] mx-auto px-5 md:px-5 lg:px-5">
          <h1 className="text-white sb-ac text-[35px] md:text-[60px] max-w-[550px]">
            Revolutionizing the future of delivery solutions
          </h1>
          <p className="text-[#8A8C8F] max-w-[340px] md:max-w-[550px] text-[11px] md:text-[16px]  py-2">
            Fast ,Reliable and customized Local delivery service for Individuals
            and businesses across Canada.
          </p>
          <div className="rounded-[8px] mt-12 md:mt-7 bg-black px-5 py-3 text-white max-w-[180px] flex flex-row justify-center items-center">
            <Link
              href=""
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("waitlist-section")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Join the Waitlist
            </Link>
          </div>
          
        </div>
      </div>

      {/* what we do section */}
      <WWD />

      {/* launch */}
      <div
        className="max-w-[1040px] mx-auto py-10 px-5 md:px-5 lg:px-5"
        id="waitlist-section"
      >
        <div className="flex flex-col md:flex-row h-[900px] md:h-[500px] launch-background  shadow-lg rounded-[15px]">
          <div className="basis-8/12  h-[500px] pl-5 md:pl-10 pt-20 px-5 md:px-0 ">
            <div>
              <h1 className="text-white text-[30px] md:text-[40px] sb-ac">
                We're Almost Ready
              </h1>

              <p className="text-[14px] md:text-[16px] text-white max-w-[490px] py-5">
                The A-Swift Delivery platform is launching soon. Stay tuned for
                a new era of delivery service that's faster, smarter, and more
                reliable
              </p>
            </div>

            <div className="pt-5 md:pt-10">
              <div className="max-w-[350px]">
                <FORM type="launch" />
              </div>
            </div>

            <div className="flex space-x-3">
              <input
                type="checkbox"
                id="subscribe"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="w-5 h-5 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 focus:ring-2"
              />
              <label
                htmlFor="subscribe"
                className="text-white max-w-[450px] text-[12px] md:text-[14px]"
              >
                Subscribe to the A-Swift community newsletter, latest updates,
                exclusive offers, and marketing emails
              </label>
            </div>
          </div>
          <div className="basis-4/12">
            <div className="flex flex-row justify-center pt-8 md:pt-5 lg:pt-20">
              <img src="/assets/launch.svg" className="h-[220px] lg:h-auto" />
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <FAQ />

      {/* SIGN UP SECTION */}
      <div className="px-0 md:px-5 lg:px-5">
        <div className="max-w-[1040px] mx-auto rounded-0 md:rounded-[10px] bg-black p-5 md:p-10 my-10 ">
          <div className="flex flex-col md:flex-row">
            <div className="basis-8/12">
              <div>
                <h1 className="text-white sb-ac text-[30px]">
                  Sign up now and be the first to know
                </h1>
                <p className="text-[#cccccc] max-w-[535px] py-2">
                  Don't miss out on the future of fast and reliable deliveries.
                  Join our community and be among the first to experience
                  A-Swift's groundbreaking delivery service when we launch. Get
                  exclusive early access, updates, and special offers straight
                  to your inbox
                </p>
              </div>
              <div className="max-w-[500px]">
                <FORM type="Sign up now" />
              </div>
            </div>
            <div className="basis-4/12">
              <img src="/assets/iphone-mock.svg" />
            </div>
          </div>

          <div className="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between items-center bg-white rounded-[10px] p-5 mb-10 md:mb-0">
            <div className="basis-8/12">
              <h1 className="text-black text-[28px] md:text-[32px] sb-ac">
                Get the A-Swift app on
              </h1>
              <p className="text-[#2d2d2d] max-w-[500px] text-[14px]">
                Download the driver app today and start earning with A-Swift
              </p>
            </div>
            <div className="basis-4/12 pt-5 lg:pt-0">
              <div className="flex flex-row gap-5">
                <div className="basis-1/2">
                  {" "}
                  <img src="/assets/gplay.svg" />
                </div>
                <div className="basis-1/2">
                  {" "}
                  <img src="/assets/gios.svg" />{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1040px] mx-auto px-5 md:px-5 lg:px-5 hidden md:flex">
        <div className="driver-background rounded-[15px] h-[450px] my-10 flex flex-row">
          <div className="basis-1/2 pt-10 pl-5 lg:pl-10">
            <div>
              <img src="/assets/aswift-logo.svg" />
            </div>
            <div className="py-3">
              <h2 className=" md:text-[30px] lg:text-[50px]">
                Earn with A-Swift
              </h2>

              <p className="md:text-[14px] lg:text-[19px]  text-[#111111] max-w-[429px]">
                Download Driver app today and start earning with A-swift
              </p>

              <p className="md:text-[14px] lg:text-[19px] font-bold pt-4">
                Join our driver's Waitlist
              </p>
              <div className="md:max-w-[280px] lg:max-w-[380px]">
                <FORM type="driver" />
              </div>

              <div className="hidden md:flex md:flex-col">
                <p className="text-black text-[14px]">
                  Download the Driver app on
                </p>
                <div className="flex flex-row gap-x-3 pt-2">
                  <img src="/assets/ggplay.svg" />
                  <img src="/assets/iosplay.svg" />
                </div>
              </div>
            </div>
          </div>
          <div className="basis-1/2 ">
            <img
              src="/assets/driver.svg"
              className="w-full h-full object-cover rounded-[15px]"
            />
          </div>
        </div>
      </div>

      <div className="flex md:hidden lg:hidden flex-col">
        <div className="driver-top">
          <div className="py-4 pl-5">
            <h2 className=" text-[30px] md:text-[30px] sb-ac ">
              Earn with A-Swift
            </h2>
            <p className="text-[12px] pt-1 pb-4 text-[#111111]">
              Drive with A-Swift - Unlock Flexible Earnings,Delivering for Your
              Community.
            </p>

            <div className="flex flex-col md:hidden py-4">
              <p className="text-black text-[14px]">
                Download the Driver app on
              </p>
              <div className="flex flex-row gap-x-3 pt-2">
                <img src="/assets/ggplay.svg" />
                <img src="/assets/iosplay.svg" />
              </div>
            </div>
          </div>
        </div>
        <div className="driver-mb-bg flex flex-col justify-end">
          <div className="px-5 mb-5">
            <p className="md:text-[14px] lg:text-[19px] font-bold pt-10 text-white sb-ac">
              Join our Driver's Waitlist
            </p>
            <div className="md:max-w-[280px] lg:max-w-[380px]">
              <FORM type="driver" />
            </div>
          </div>
        </div>
      </div>
      <div
        className="px-5 md:px-5 lg:px-5 bg-black md:bg-transparent"
        id="contactus"
      >
        <div className="max-w-[1040px] mx-auto rounded-0 md:rounded-[10px] bg-black p-10 my-0 md:my-10">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="md:basis-7/12 lg:basis-8/12">
              <div>
                <h1 className="text-white sb-ac text-[30px]">
                  We'd love to hear from you!
                </h1>
                <p className="text-[#cccccc] text-[12px] md:text-[16px] max-w-[535px] py-2">
                  Have questions or need support? Whether you're a customer,
                  business, or driver, we're here to help. Reach out to us
                  anytime and we'll get back to you as soon as possible.
                </p>
              </div>
            </div>
            <div className="md:basis-5/12 lg:basis-4/12">
              <div className="flex flex-row items-center gap-4 py-4">
                <div>
                  <img src="/assets/cal.svg" />
                </div>
                <div>
                  <p className="text-white">+1 306-880-3310</p>
                </div>
              </div>
              {/* <div className="flex flex-row items-center gap-4 py-4">
              <div>
                <img src="/assets/loc.svg" />
              </div>
              <div>
                <p className="text-white">123 A-Swift Street, City, Country</p>
              </div>
            </div> */}
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-1 md:gap-5 pt-0 md:pt-10">
            <div className="flex flex-row items-center gap-4 md:gap-2 lg:gap-4 py-4">
              <div>
                <img src="/assets/gmail.svg" />
              </div>
              <div>
                <p className="text-white md:text-[12px] lg:text-[16px]">
                  info@aswift.ca
                </p>
              </div>
            </div>

            <div className="flex flex-row items-center gap-4  md:gap-2 lg:gap-4 py-4">
              <div>
                <img src="/assets/x.svg" />
              </div>
              <div>
                <p className="text-white md:text-[12px] lg:text-[16px]">
                  @A-Swift
                </p>
              </div>
            </div>

            <div className="flex flex-row items-center gap-4  md:gap-2 lg:gap-4 py-4">
              <div>
                <img src="/assets/instagram.svg" />
              </div>
              <div>
                <p className="text-white md:text-[12px] lg:text-[16px]">
                  @Aswift_delivery
                </p>
              </div>
            </div>

            <div className="flex flex-row items-center gap-4  md:gap-2 lg:gap-4 py-4">
              <div>
                <img src="/assets/Facebook.svg" />
              </div>
              <div>
                <p className="text-white md:text-[12px] lg:text-[16px]">
                  @A-Swift.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </main>
  );
}
